import { CampaignAdCostDialogComponent } from './campaign-ad-cost/dialogs/campaign-ad-cost-details.component';
import { CampaignAdCostComponent } from './campaign-ad-cost/campaign-ad-cost.component';
import { CampaignEditDialogComponent } from './campaign/dialogs/campaign-edit.component';
import { CampaignComponent } from './campaign/campaign.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CampaignAdCostReportComponent } from './campaign-ad-cost-report/campaign-ad-cost-report.component';
import { CampaignMemberListComponent } from './campaign/campaign-member-list/campaign-member-list.component';
import { CampaignReportMemberListComponent } from './campaign-ad-cost-report/campaign-report-member-list/campaign-report-member-list.component';
import { CampaignClicksDialogComponent } from "./campaign-ad-cost-report/campaign-clicks/campaign-clicks.component";
import { AppPermissionKeys } from '@core/models/app-permissions.model';
import { WhatsappCampaignComponent } from './whatsapp-campaign/whatsapp-campaign.component';
import { WhatsappCampaignSettingDialogComponent } from './whatsapp-campaign/dialogs/whatsapp-campaign-setting/whatsapp-campaign-setting.component';

const routes: Routes = [
  {
    path: 'campaign',
    component: CampaignComponent,
    data: { permissions: AppPermissionKeys.view_campaigns_list }
  },
  {
    path: 'ad-cost',
    pathMatch: 'full',
    component: CampaignAdCostComponent,
    data: { permissions: AppPermissionKeys.view_ad_costs_list }
  },
  {
    path: 'ad-reports',
    pathMatch: 'full',
    component: CampaignAdCostReportComponent,
    data: { permissions: AppPermissionKeys.view_campaign_ad_reports }
  },
  {
    path: 'whatsapp-campaign',
    pathMatch: 'full',
    component: WhatsappCampaignComponent,
    data: { permissions: AppPermissionKeys.view_whatsapp_campaign_list }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    CampaignEditDialogComponent,
    CampaignAdCostDialogComponent,
    CampaignMemberListComponent,
    CampaignReportMemberListComponent,
    CampaignClicksDialogComponent,
    WhatsappCampaignSettingDialogComponent
  ]
})
export class MarketeerRoutingModule { }
